import log from 'loglevel';
import React, { useState, useEffect, useRef } from 'react';
import { usePlayerContext } from './Context';
import PlayerInstance from './Instance';
import {
  ClickAction,
  Control,
  ControlsPosition,
  Events,
  Responsive,
  State,
  ControlComponentItem,
  ProgressBarPosition,
  ToggleControlsChangedEvents,
} from '../types/player';

import ProgressBar from './controls/ProgressBar';

import ControlList from './ui/ControlsList';
import { doc } from 'prettier';

const Controls = () => {
  const [isReady, setReady] = useState(false as boolean);
  const { sdk } = usePlayerContext();
  const [toggleControls, setToggleControls] = useState(
    sdk.options().getControls().getSettings().click === ClickAction.CONTROLS
      ? 0
      : -1,
  );
  const listeners = useRef<() => void>();
  const [controls, setControls] = useState(sdk.options().getControls());
  const [controlsHide, setControlsHide] = useState(false);
  const [controlMiddleHide, setControlMiddleHide] = useState(false);

  const controlZoneBottom = useRef<HTMLDivElement>(null);

  const isVisible = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      if (listeners.current) {
        listeners.current();
      }
    };
  }, []);

  /*useEffect(() => {
    if (
      sdk.options().getControls().getSettings().click ===
        ClickAction.CONTROLS ||
      !isReady ||
      sdk.options().isBackground() ||
      !controlZoneBottom.current
    ) {
      return;
    }
    const onTransitionEnd = () => {
      if (controlsHide || (!sdk.isStarted() && sdk.options().getPoster()))
        return;
      
        console.log('onTransitionEnd');
      
    };

    const onTransitionStart = (e: any) => {
      
      if(e.propertyName !== 'opacity')
        return;

      if(e.pseudoElement)
        return;

      if (controlsHide || (!sdk.isStarted() && sdk.options().getPoster()))
        return;

      
      const computedStyle = window.getComputedStyle(controlZoneBottom.current!);

      let element = controlZoneBottom.current!;

      console.log('computedStyle.opacity', computedStyle.opacity);

      if(computedStyle.opacity == '0' || computedStyle.opacity == '1')
        isVisible.current = computedStyle.opacity == '0' ? false : true;
      else {
        isVisible.current = !isVisible.current;
      }

      sdk.toggleControlsChanged(
        isVisible.current
          ? ToggleControlsChangedEvents.SHOW
          : ToggleControlsChangedEvents.HIDE,
      );

    };

    
    console.log('controlZoneBottom controlZoneBottom')
    controlZoneBottom.current.addEventListener(
      'transitionend',
      onTransitionEnd,
    );
    //onTransitionEnd();

    controlZoneBottom.current.addEventListener(
      'transitionstart',
      onTransitionStart,
    );
    onTransitionStart({
      propertyName: 'opacity'
    });

    return () => {
      controlZoneBottom.current?.removeEventListener(
        'transitionend',
        onTransitionEnd,
      );
      controlZoneBottom.current?.removeEventListener(
        'transitionstart',
        onTransitionStart,
      );
    };
    
  }, [isReady, controlsHide]);*/

  useEffect(() => {
    sdk.on(Events.READY, () => {
      log.debug('Controls', 'Ready');
      setReady(true);
    });

    sdk.on(Events.BIG_BUTTON_CHANGED, (button: string | null) => {
      setControlMiddleHide(button !== null);
      if (
        sdk.options().getControls().getBigButton()
          ?.showControlBigButtonDisplayed === false
      ) {
        if (button === null) {
          setControlsHide(false);
        } else setControlsHide(true);
      }
    });
  }, [sdk]);

  useEffect(() => {
    listeners.current = sdk.on(Events.TOGGLE_CONTROLS, () => {
      if (toggleControls === -1) return;
      sdk.toggleControlsChanged(
        toggleControls === 1
          ? ToggleControlsChangedEvents.HIDE
          : ToggleControlsChangedEvents.SHOW,
      );
      setToggleControls(toggleControls === 1 ? 0 : 1);
    });
    return () => {
      if (listeners.current) {
        listeners.current();
      }
    };
  }, [toggleControls]);

  if (!isReady || controlsHide || sdk.options().isBackground()) {
    return null;
  }

  const controlListTopLeft = controls.list(ControlsPosition.TOP_LEFT);
  const controlListTopRight = controls.list(ControlsPosition.TOP_RIGHT);
  const controlListBottomLeft = controls.list(ControlsPosition.BOTTOM_LEFT);
  const controlListBottomRight = controls.list(ControlsPosition.BOTTOM_RIGHT);
  const controlListMiddle = controls.list(ControlsPosition.MIDDLE);

  const progressBarBottom =
    controls.getProgressBar().position !==
      ProgressBarPosition.CENTER_BOTTOM_CONTROLS &&
    controls.getProgressBar().show !== false;

  const progressBarControls =
    controls.getProgressBar().position ===
      ProgressBarPosition.CENTER_BOTTOM_CONTROLS &&
    controls.getProgressBar().show !== false;

  let gradientClassName = '-container';
  if (
    (controlListBottomLeft && controlListBottomLeft.length > 0) ||
    (controlListBottomRight && controlListBottomRight.length > 0) ||
    progressBarBottom
  )
    gradientClassName += '-bottom';
  if (
    (controlListTopLeft && controlListTopLeft.length > 0) ||
    (controlListTopRight && controlListTopRight.length > 0)
  )
    gradientClassName += '-top';
  if (
    gradientClassName !== '-bottom-top' &&
    controlListMiddle &&
    controlListMiddle.length > 0
  )
    gradientClassName = '-container-full';

  const toggleControlsClassName = `${sdk.getClassNamePrefix()}-player-controls${toggleControls !== -1 ? (toggleControls === 1 ? '-show' : '-hide') : '-hover'}`;

  return (
    <div
      className={`${sdk.getClassNamePrefix()}-player-controls ${sdk.getClassNamePrefix()}-player-controls${gradientClassName} ${toggleControlsClassName}`}
    >
      {(controlListTopLeft || controlListTopRight) && (
        <div
          className={`${sdk.getClassNamePrefix()}-player-controls-zone ${sdk.getClassNamePrefix()}-player-controls-top ${controls.getSettings().stickyTop === true ? `${sdk.getClassNamePrefix()}-player-controls-top-sticky` : ''}`}
        >
          <ControlList controls={controlListTopLeft} position={'topLeft'} />

          <ControlList controls={controlListTopRight} position={'topRight'} />
        </div>
      )}
      {controlListMiddle && controlMiddleHide === false && (
        <div
          className={`${sdk.getClassNamePrefix()}-player-controls-zone ${sdk.getClassNamePrefix()}-player-controls-middle`}
        >
          <ControlList controls={controlListMiddle} />
        </div>
      )}

      {(controlListBottomLeft ||
        controlListBottomRight ||
        progressBarBottom ||
        controls.getProgressBar().position ===
          ProgressBarPosition.CENTER_BOTTOM_CONTROLS) && (
        <div
          className={`${sdk.getClassNamePrefix()}-player-controls-zone ${sdk.getClassNamePrefix()}-player-controls-bottom ${controls.getSettings().stickyBottom === true ? `${sdk.getClassNamePrefix()}-player-controls-bottom-sticky` : ''}`}
          ref={controlZoneBottom}
        >
          <ControlList
            controls={controlListBottomLeft}
            position={'bottomLeft'}
          />
          <div
            className={`${sdk.getClassNamePrefix()}-player-controls-bottom-center`}
          >
            {progressBarControls && <ProgressBar />}
          </div>
          <ControlList
            controls={controlListBottomRight}
            position={'bottomRight'}
          />
          {progressBarBottom && <ProgressBar />}
        </div>
      )}
    </div>
  );
};

export default Controls;
